module.exports = __webpack_public_path__ + "c664f1ceca5f2d30546b7edd25e0b8a3.png";